<style>
.codigo-input {
    max-width: 150px;
    letter-spacing: 5px;
    font-weight: 600 !important;
    text-align: center !important;
    font-size: 18pt !important;
    border: 2px solid #CCC !important;
    padding-top: 0.7rem !important;
    padding-bottom: 0.7rem !important;
}

.codigo-input:focus {
    border-color: #5776f0 !important;
}
</style>
<template>
    <div class="card card-plain"
        style="margin: 0 auto; max-width: 450px; background: #FFF; -webkit-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); -moz-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);">
        <div class="pb-0 card-header text-start">
            <h4 class="font-weight-bolder">Verificação de identidade</h4>

            <p class="mb-0" style="line-height: 1.3">
                Digite o código recebido, abaixo:
            </p>
        </div>

        <div class="card-body">

            <input type="text" name="codigo" class="form-control codigo-input px-3" maxlength="6" v-model="codigo" ref="codigoInput"
                @keyup="codigoInputKeyup" />

            <div class="p-0 m-0">
                <argon-button :disabled="isLoading || codigo.length != 6" class="mt-4" variant="gradient"
                    color="warning" fullWidth size="lg" @click="confirmarCodigo">
                    {{ isLoading ? 'VERIFICANDO...' : 'CONFIRMAR' }}
                </argon-button>
            </div>

            <div class="horizontal-divider my-3"></div>

        </div>

        <div class="px-4 pt-0 text-center card-footer px-lg-2">
            <p class="mx-auto mb-4 text-sm">
                Dúvidas?
                <a href="https://api.whatsapp.com/send?phone=553537311118" target="_blank"
                    class="text-warning text-gradient font-weight-bold">Entre em contato pelo WhatsApp</a>
            </p>
            <button class="btn btn-light btn-sm" @click="voltar">VOLTAR</button>
        </div>
    </div>
</template>
<script>
// import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import ArgonButton from "@/components/ArgonButton.vue";
import api from "../services/api.js";
import { errorMessage } from '../helpers/helper.js'

let user = {}

let isLoading = false

let codigo = ''

let confirmandoCodigo = false

export default {
    name: "ConfirmarCodigo",
    components: {
        ArgonButton,
    },
    data() {
        return {
            codigo,
            isLoading,
        }
    },
    beforeMount() {
    },
    mounted() {
        if (window.innerWidth > 768)
            this.$refs.codigoInput.focus()
    },
    async created() {

        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
    computed: {
    },
    methods: {
        codigoInputKeyup() {
            if (this.codigo.length === 6)
                this.confirmarCodigo()
        },

        async confirmarCodigo() {
            if (this.confirmandoCodigo)
                return false
            this.confirmandoCodigo = true
            const confirmacao = await api.confirmarCodigo(this.codigo)
            this.confirmandoCodigo = false
            if (!confirmacao) {
                errorMessage(this, 'Este código é inválido ou já expirou.')
                return false
            }

            this.$router.push({ name: 'Termos' })
        },

        voltar() {
            this.$router.push({ name: 'Verificacao' })
        },
    }
};
</script>